import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  @Input() title?: string;
  @Output() backClicked: EventEmitter<void> = new EventEmitter();

  onBackButtonClicked() {
    this.backClicked.emit();
  }
}
